/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  rebateTBillSearchResult: [],
  planViewHistory: [],
  allTBillList: [],
  editedData: [],
  extraState: {
    fullScreenView: false,
    edit: false,
  },
  errorField: {
    errorMessages: [],
    isError: false,
    showRateErr: false,
  },
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_TBILL_DATA:
      return { ...state, allTBillList: action.payload };
    case actionTypes.GET_TBILLTABLE_DATA:
      return {
        ...state,
        rebateTBillSearchResult: action.rebateTBillSearchResult,
      };
    case actionTypes.GET_TBILLTABLE_EDITED_DATA:
      return { ...state, editedData: action.editedData };
    case actionTypes.VIEW_HISTORY:
      return { ...state, planViewHistory: action.planViewHistory };
    case actionTypes.TBILL_ERROR:
      return { ...state, errorField: action.errorField };
    case actionTypes.TBILL_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.TBILL_CLEAR_REDUX_STORE:
      return { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
